import { useState } from 'react';

const useToggle = (initialState = false): [boolean, () => void] => {
  const [state, setState] = useState(initialState);

  return [state, () => setState(!state)];
};

export default useToggle;
